module.exports = __webpack_public_path__ + "img/ico-cobrar.e8ec60e9.svg";